require("dotenv").config();
export const AUTH_URL = "";
export const SUBDOMAIN_URL = "";
export const APPLICATIONS_URL = "";
export const LOGIN_POST = "/login";
export const LOGOUT_POST = "/users/logout";
export const USER_REGISTER = "/Auth/Register";
export const RECOVERY_POST = "/users/recovery-password";
export const RESET_POST = "/users/reset-password";
export const SUBDOMAINS = "/subdomains";
export const SUBDOMAINS_SEARCH = "/subdomains/search";
export const APPLICATIONS = "/applications";
export const APPLICATIONS_SEARCH = "/applications/search";
export const RIPSAPP_JS = "";
export const RIPSAPP_STYLES = "";
export const MODULES_URL = "";
export const MODULES = "/modules";
export const MODULES_SEARCH = "/modules/search";
export const OPERATIONS_URL = "";
export const OPERATIONS = "/operations";
export const OPERATIONS_SEARCH = "/operations/search";
export const FUNCTIONALITIES_URL = "";
export const FUNCTIONALITIES = "/functionalities";
export const FUNCTIONALITIES_SEARCH = "/functionalities/search";
export const ROLES_API = "";
export const ROLES_PATH = "/roles";
export const USERS_API = "";
export const USERS_PATH = "/users";
export const SESSION_TIME_EXPIRATION = 900000;
export const APP_URL = process.env.REACT_APP_APPSERVER;
export const APP_URL_CONTRACT = process.env.REACT_APP_APPSERVER_CONTRACT;
export const APP_URL_NOTIFICATION =
  process.env.REACT_APP_APPSERVER_NOTIFICATION;
export const CHARGES = "/charge/";
export const PROCESS = "/process/";
export const ACTIVE_PROCESS = "/process/process-by-status/ACTIVO";
export const REQUISITIONSAVE = "/requisition/save";
export const REQUISITIONFINISH = "/requisition/finish";
export const REQUISITIONSEARCH = "/requisition/criteria/";
export const REQUISITIONSEARCH_USER_CHARGE =
  "/requisition/criteria-user-charge/";
  export const REQUISITIONSEARCH_ALL =
  "/requisition/criteria/all-user";
export const REQUISITIONCANCEL = "/requisition/cancel";
export const REQUISITIONREJECT = "/requisition/reject";
export const REQUISITIONPUBLISH = "/requisition/publish";
export const REQUISITIONCLOSE = "/requisition/close";
export const REQUISITIONAPPROVE = "/requisition/approve";
export const REQUISITION = "/requisition/";
export const NUEVO_CARGO = "Nuevo Cargo";
export const AUMENTO_DE_PLANTA = "Aumento De Planta";
export const EN_ELABORACION = "EN ELABORACIÓN";
export const PENDIENTE_DE_APROBACION = "PENDIENTE DE APROBACIÓN";
export const REGIONAL = "/regional";
export const CARGO = "/profile/";
export const USUARIOS = "/person";
export const EXTERNAL = "/external";
export const MAESTRAS = "/with-out-entity/";
export const ACTIVE_REGIONALS = "/regional/regional-by-status/ACTIVO";
export const ACTIVE_PUBLIC_REGIONALS =
  "/regional/regional-by-status-public/ACTIVO";
export const CHARGEBYSTATUS = "charge-by-status/";
export const CVFINISH = "/curriculum/";
export const CV = "/cv/";
export const CVBYDOCUMENTANDTYPE = "/curriculum/by-document-and-type/";
export const PERSONBYDOCUMENTANDTYPE = "/person/by-document-and-type/";
export const PERSONBYDOCUMENTANDTYPEAUTH = "/person/auth/by-document-and-type/";
export const PROVINCES = "/location/province";
export const TOWNSBYPROVINCE = "/location/towns-by-province/";
export const ERROR_MESSAGE =
  "Ocurrió un error procesando la solicitud, inténtelo nuevamente";
export const REQUIRED_MESSAGE = "Este campo es obligatorio";
export const PROFESSION = "/profession/";
export const ROLE = "/role/";
export const ASSIGNMENT_ROLES = "assignment-functionalities";
export const RECOVERY = "/user/recover-password";
export const CHANGE_PASSWORD = "/user/reset-password";
export const MODULE = "/module";
export const FUNCTIONALITY = "/functionality/";
export const VACANT = "/vacant/";
export const USERINTERNAL = "/user/internal";
export const ACTIVE_VACANT = "/vacant/vacant-by-status/ACTIVO";
export const USERSEARCH = "/user/criteria/";
export const VACANTSEARCH = "/vacant/criteria-user/";
export const ROLESTATUS = "/role/status/";
export const ROLEBYSTATUS = "/role/role-by-status/";
export const VACANTSEARCHRH = "/vacant/criteria-hr/";
export const VACANTPUBLICSEARCH = "/vacant/criteria-external-users/";
export const CLOSEVACANT = "/vacant/close";
export const DIRECTOR_DE_RECURSOS_HUMANOS = "DIRECTOR DE RECURSOS HUMANOS";
export const FORMAT_MESSAGE_PHOTO =
  "Solo se permiten archivos de tipo PDF, JPG, PNG, JPEG";
export const FORMAT_MESSAGE_CV = "Solo se permiten archivos de tipo PDF";
export const FORMAT_MESSAGE = "Solo se permiten archivos de tipo PDF";
export const USER = "/user/";
export const PROFILESEARCH = "/profile/criteria-profile/";
export const APPLY_VACANT = "/vacant/apply-vacancy";
export const SIZE_MESSAGE =
  "El peso máximo permitido para los archivos son 5Mb";
export const CLAUSE = "/clause/criteria";
export const CLAUSE_RAIZ = "/clause";
export const CONTRACTTYPE = process.env.REACT_APP_APPSERVER_PATH_CONTRACT;
//export const CONTRACTTYPE = "/contract-type";
export const CONTRACTTYPEACTIVE = "/contract-type?status=Activo";
export const CONTRACTTYPEVALUES = "/contract-type";
export const CONTRACTTYPEFORMAT = "/contract-type-format?status=ACTIVO";
export const CONTRACTBYTYPEFORMAT = "/contract-type-format";
export const CONTRACTTYPEFORMATE = "/contract-types-list";
export const CONTRACTTYPEFORMATCLAUSE = "/contract-type-format-clause";
//export const CONTRACT_APP_URL_PROVI = "http://contract-dot-sae-dev.ue.r.appspot.com";
export const POSTULATESTATUS = "/vacant/postulate/status";
export const APPLICATIONSTAGE = "/vacant/application-stage/";
export const APPLICATION_STAGE_RESULT_LIST =
  "/vacant/application-stage/result-list";
export const START_SELECTION_PROCESS =
  "/vacant/postulate/start-selection-process";
export const POSTULATES_STATUS = "/vacant/postulate/status";
export const POSTULATE = "postulate/";
export const POSTULATE_CRITERIAL = "criteria-hr-or-assistant/";
export const BY_VACANTID = "by-vacantId/";
export const USERNAME = "find-by-username/";
export const CONTRACTTYPECLAUSES = "/contract-type-clause";
export const CONTRACTCRITERIA = "/contract/criteria/";
export const COMPANY = "/company-data";
export const CONTRACT = "/contract";
export const USERSHORTCUT = "/user/shortcut/";
export const DOCUMENTCONTRACT = "/contract/generate-report";
export const CONTRACTCANCEL = "/contract/cancel/";
export const CONTRACTFINISH = "/contract/finish/";
export const APPLICATIONSTAGE_BY_POSTULATE =
  "/vacant/application-stage/by-postulate/";
export const NOTIFICATION = "/notification/";
export const ALL_UNCHECKED = "all-unchecked";
export const CONTROLLER_PERMISSION = "request/management";
export const APP_URL_REQUEST_MANAGEMENT =
  process.env.REACT_APP_APPSERVER_SAE_REQUEST_MANAGEMENT;
export const APP_URL_MEDICAL = process.env.REACT_APP_APPSERVER_MEDICAL;
export const LABORATORYSEARCH = "/medical-lab/criteria/";
export const LABORATORYCREATE = "/medical-lab/";
export const LABORATORYEDIT = "/medical-lab/";
export const MEDICALEXAM = "medical-exam/";
export const TYPEEXAM = "typeExams/";
export const CONTRACTTYPEFORMATS = "/contract-type-format/by-contracttype/";
export const REPRESENTATION = "/representation-expense/";
export const REPRESENTATIONCOST = "/representation-expense/by-contract/";
export const REPRESENTATIONCOSTGENERATE =
  "/representation-expense/generate-report/";
export const VALIDATEPREVIOUSCONTRACT =
  "/contract/validate-previous-contract-active-employee/by-document/";
export const CONTRACTRENEW = '/contract/renew/';
export const REDASH_REPORT = process.env.REACT_APP_APPSERVER_REDASH_URL;
export const POSTULATE_BY_DOC_AND_NUMBER = '/vacant/postulate/by-person-document-and-status/';
export const PROFESSIONAUTOCOMPLETE = "/profession/autocomplete/";
export const LEARNING ="https://lms.cuidadoseguro.com.co/";
export const COLLECTIVESERVICE = 'collective-service/';
export const NORMALUSER = 'c3ee84b698ab7c8b1c8161180fc644c3cad1cd9b';
export const APPROVER = 'ca76a54021477153361f25b6ec3fb42378a8638c';
export const RHMANAGE = '51bd95353aeda6615433bea21896c893ef5e62dc';
export const USERBYDOCUMENT = '/user/by-document/';
export const CONTRACTACTIVEBYDOCUMENT = '/contract/active/by-document/';
export const ENDOWMENT = '/endowment/';
export const TYPEENDOWMENT = '/typeEndowment/';
export const DOWLOADENDOWMENTFILE = '/endowment/card-delivery/generate-report/';
export const DOWLOADENDOWMENT = '/endowment/endowment-delivery/generate-report/';
export const EMPLOYEE = '/employee/';
export const CONTRACTEMPLOYEE = '/contract/by-employee-id/';
export const FINGERPRINTCARD = '/endowment/card-delivery/generate-signed-report/';
export const FINGERPRINTENDOWMENT = '/endowment/endowment-delivery/generate-signed-report/';
export const REPRESENTATIONEXPENSE = '/representation-expense/by-contract/';

//Detalle
